(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.buyout-x.web.view
  (:require
   [frontend.ui.component.chart.view :refer [chart]]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.esg.incidents.view
    :refer [incidents-card]]
   [frontend.ui.component.lp-portal.report.esg.key-perf-indicators.view
    :refer [key-perf-indicators-card]]
   [frontend.ui.component.lp-portal.report.esg.targets-and-strategy.view
    :refer [targets-and-strategy-card]]
   [frontend.ui.component.lp-portal.report.overview.big-figures.view
    :refer [overview-figures-card]]
   [frontend.ui.component.lp-portal.report.overview.recent-development-figures.view
    :refer [recent-development-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.basic-information.view
    :refer [basic-information-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.view
    :refer [largest-investments-at-fair-value-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-by-country-at-fair-value.view
    :refer [portfolio-by-country-at-fair-value-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.view
    :refer [return-development-card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.tabbed-card.view :refer [tabbed-card]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]))

(defn- tearsheet-section
  [tearsheet props]
  (let [{:keys [largest-investments-at-fair-value
                portfolio-by-country-at-fair-value]}
        tearsheet]
    [section
     "Tear sheet"
     (str "tearsheet-"
          (some->> props
                   :report
                   :db/id))
     [:div
      [grid/row {}
       [grid/column {:large 6}
        [return-development-card tearsheet props]]
       [grid/column {:large 6}
        [largest-investments-at-fair-value-card largest-investments-at-fair-value props]
        [portfolio-by-country-at-fair-value-card portfolio-by-country-at-fair-value props]]]
      [:div
       [basic-information-card tearsheet props]]]]))

(defn- overview-section
  [overview props]
  (let [{:keys [overview-figures
                recent-development-text
                recent-development
                total-investment
                portfolio-at-fair-value
                historical-net-cash-flows]}
        overview]
    [section
     "Overview"
     (str "overview-"
          (some->> props
                   :report
                   :db/id))
     [:div
      [overview-figures-card overview-figures props]
      [recent-development-card recent-development-text recent-development props]
      [tabbed-card
       {:selected :total-investment}
       [{:id    :total-investment
         :title "Total investment"
         :body ^{:key :total-investment}
                [:<>
                 [chart (:figures total-investment)]
                 [text-content/optional-footnote total-investment props]]}
        {:id    :portfolio-at-fair-value
         :title "Portfolio at fair value"
         :body  ^{:key :portfolio-at-fair-value}
                [:<>
                 [chart (:figures portfolio-at-fair-value)]
                 [text-content/optional-footnote portfolio-at-fair-value props]]}
        {:id    :historical-net-cash-flows
         :title "Historical net cash flows"
         :body  ^{:key :historical-net-cash-flows}
                [:<>
                 [chart (:figures historical-net-cash-flows)]
                 [text-content/optional-footnote historical-net-cash-flows props]]}]]]]))

(defn- details-and-figures-section
  [{:keys [current-portfolio exited-portfolio investment-summary cash-flows-and-assets]} props]
  [section
   "Details and figures"
   (str "details-and-figures-"
        (some->> props
                 :report
                 :db/id))
   [:div
    ;; TODO --> Remove "Country"
    [tabular-card/dynamic-table "Current portfolio, €" current-portfolio props]
    [tabular-card/dynamic-table "Exited portfolio, €" exited-portfolio props]
    [tabular-card/dynamic-table "Investment summary, €" investment-summary props]
    [tabular-card/dynamic-table "Cash flows and assets, €" cash-flows-and-assets props]]])

(defn esg-section
  [{:keys [esg-targets-and-strategy-text incidents-text key-perf-indicators gresb] :as data}
   props]
  [section
   "Sustainability"
   (str "esg-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [targets-and-strategy-card esg-targets-and-strategy-text props]
    [key-perf-indicators-card key-perf-indicators gresb props]
    [incidents-card incidents-text props]]])

(defn buyout-x
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [tearsheet overview details-and-figures esg investors]} fund-ui-data]
    [:div
     [:div {:id :tearsheet}
      [:div
       [tearsheet-section tearsheet props]]]
     [:div {:id :overview}
      [:div
       [overview-section overview props]]]
     [:div {:id :esg}
      [:div [esg-section esg props]]]
     [:div {:id :details-and-figures}
      [:div
       [details-and-figures-section details-and-figures props]]]
     [:div
      [:div
       [section
        "Investors, €"
        (str "investors-"
             (some->> props
                      :report
                      :db/id))
        [:div
         [tabular-card/dynamic-table "" investors props]]]]]]))
